import { Button, Stack, Typography } from "@mui/material";
import styles from "./styles";
import { PaginationProps } from "./types";
import { useTranslation } from "react-i18next";

const CustomPagination = ({
  totalCount,
  page,
  pageSize,
  currentPageDataCount,
  handlePageChange,
}: PaginationProps) => {
  const recordCountFrom = page > 1 ? (page - 1) * pageSize + 1 : 1;
  const recordCountTo = recordCountFrom - 1 + currentPageDataCount;
  const { t } = useTranslation();
  return (
    <Stack
      justifyContent="space-between"
      spacing={2}
      direction="row"
      alignItems="center"
      sx={styles.container}
    >
      <Typography sx={styles.recordCountText}>
        {`${recordCountFrom} - ${recordCountTo} of ${totalCount} ${t("items")}`}
      </Typography>
      <Stack
        justifyContent="space-between"
        direction="row"
        alignItems="center"
        gap="1rem"
      >
        <Button
          sx={styles.button}
          onClick={() => handlePageChange(page - 1)}
          disabled={page === 1}
        >
          {t("previous")}
        </Button>
        <Button
          sx={styles.button}
          onClick={() => handlePageChange(page + 1)}
          disabled={recordCountTo === totalCount}
        >
          {t("next")}
        </Button>
      </Stack>
    </Stack>
  );
};

export default CustomPagination;
